import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/ReportQueueHistorySettings'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class ReportQueueHistorySettingsStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "ReportQueueHistorySettingsStore",
			variables: false,
		})
	}
}

export async function load_ReportQueueHistorySettings(params) {
  await initClient()

	const store = new ReportQueueHistorySettingsStore()

	await store.fetch(params)

	return {
		ReportQueueHistorySettings: store,
	}
}
